import React from "react";
import Document from "./document";
import Admin from "./admin";

/**
 * Presenation Routes list
 * @param {Object} auth
 * @param {Function} checkAuthSession
 */
const MarketingMaterialComponent = (auth, checkAuthSession) => {
  const routes = (
    <>
      {Document(auth, checkAuthSession)}
      {Admin(auth, checkAuthSession)}
    </>
  );

  return routes;
};

export default MarketingMaterialComponent;
